/*
 * jqZoom (GroundLuxe build, Oct 2026)
 * Performance rewrite of the original plugin, same visual behavior:
 *  - Zoom is set up on the FIRST mouse hover of an image instead of at page load
 *    (the original downloaded a full-size copy of every gallery image up front).
 *  - Removed the "?date=" cache-buster that forced every image to download twice.
 *  - Skipped entirely on touch devices, where hover-zoom can't be used.
 */
(function($){
    var SPACING = 15;
    var canHover = !window.matchMedia || window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    $.fn.jqZoom = function(options){
        options = options || {};
        if (!canHover) { return this; }
        $(this).each(function(i, dom){
            var me = $(dom);
            var $box = me.closest(".zoom-box");
            if (!$box.length || me.data("jqzoomBound")) { return; }
            me.data("jqzoomBound", true);
            $box.one("mouseenter.jqzoominit", function(){
                _initZoom(me, options.selectorWidth, options.selectorHeight);
                var imgUrl = options.zoomImgUrl ? options.zoomImgUrl : me.attr("src");
                _initViewer(me, imgUrl, options.viewerWidth, options.viewerHeight);
                $box.find(".zoom-selector").css("display", "block");
            });
        });
        return this;
    };

    var _initZoom = function(target, sWidth, sHeight){
        var $zoom = $("<div />").addClass("zoom-selector").width(sWidth).height(sHeight);
        target.after($zoom);
        target.closest(".zoom-box").on({
            mousemove: function(e){
                var mouseX = e.pageX - $(this).offset().left;
                var mouseY = e.pageY - $(this).offset().top;
                var halfSWidth = sWidth / 2, halfSHeight = sHeight / 2;
                var realX, realY;
                if (mouseX < halfSWidth) {
                    realX = 0;
                } else if (mouseX + halfSWidth > target.width()) {
                    realX = target.width() - sWidth;
                } else {
                    realX = mouseX - halfSWidth;
                }
                if (mouseY < halfSHeight) {
                    realY = 0;
                } else if (mouseY + halfSHeight > target.height()) {
                    realY = target.height() - sHeight;
                } else {
                    realY = mouseY - halfSHeight;
                }
                $zoom.css({ left: realX, top: realY });
                var viewerX = realX * ($(this).find(".viewer-box>img").width() - $(this).find(".viewer-box").width()) / (target.width() - sWidth);
                var viewerY = realY * ($(this).find(".viewer-box>img").height() - $(this).find(".viewer-box").height()) / (target.height() - sHeight);
                $(this).find(".viewer-box>img").css({ left: -viewerX, top: -viewerY });
            },
            mouseenter: function(){
                $zoom.css("display", "block");
                $(this).find(".viewer-box").css("display", "block");
            },
            mouseleave: function(){
                $zoom.css("display", "none");
                $(this).find(".viewer-box").css("display", "none");
            }
        });
    };

    var _initViewer = function(target, imgUrl, vWidth, vHeight){
        var $viewer = $("<div />").addClass("viewer-box").width(vWidth).height(vHeight);
        var $zoomBox = target.closest(".zoom-box");
        $viewer.css({ left: target.width() + SPACING, top: 0 });
        _setOriginalSize(imgUrl, function(oWidth, oHeight){
            var $img = $("<img />").attr("src", imgUrl).attr("alt", "").width(oWidth).height(oHeight);
            $viewer.append($img);
            target.after($viewer);
            if ($zoomBox.is(":hover")) { $viewer.css("display", "block"); }
        });
    };

    var _setOriginalSize = function(imgUrl, callback){
        var newImg = new Image();
        $(newImg).on("load", function(){
            callback(newImg.naturalWidth || newImg.width, newImg.naturalHeight || newImg.height);
        });
        newImg.src = imgUrl;
    };
})(jQuery);
